import { Spacer, Switch, Text, WarningIcon } from '@sparemin/blockhead';
import * as React from 'react';
import { Col } from 'react-bootstrap';
import Accordion from 'components/Accordion';
import useToggle from 'hooks/useToggle';
import { KeyImageType } from 'types';
import { block } from './utils';

export type SlideDynamicImageFieldProps = {
  value?: KeyImageType;
  isDynamicImageAvailable?: boolean;
  onChange?: (value: KeyImageType) => void;
};

const SlideDynamicImageField: React.FC<SlideDynamicImageFieldProps> = ({
  value,
  isDynamicImageAvailable = true,
  onChange,
}) => {
  const [isExpanded, onToggle] = useToggle(
    value === 'mainImage' || !isDynamicImageAvailable,
  );

  return (
    <Col xs={12}>
      <Accordion
        isExpanded={isExpanded}
        title="Make image dynamic"
        className={block('dynamic-image-field')}
        onToggle={() => onToggle(!isExpanded)}
      >
        <Spacer
          space="8px"
          orientation="horizontal"
          align="flex-start"
          justify="center"
          className={block('contents-inner')}
        >
          <Spacer
            space="8px"
            orientation="horizontal"
            align="flex-start"
            justify="center"
            className={block('message', {
              unavailable: !isDynamicImageAvailable,
            })}
          >
            {!isDynamicImageAvailable && (
              <WarningIcon color="#F9EB69" width={20} height={20} />
            )}

            <Text variant="label" size="10px" weight="400" lineHeight="13px">
              {!isDynamicImageAvailable
                ? 'Dynamic text not available for this clip. Replace with a  static image.'
                : "Automatically replace this image with the selected clip's corresponding chapter art, if chapter art is unavailable, we'll use episode art."}
            </Text>
          </Spacer>

          <Switch
            isDisabled={!isDynamicImageAvailable}
            isSelected={isDynamicImageAvailable && value === 'mainImage'}
            onChange={isSelected => onChange(isSelected ? 'mainImage' : null)}
          />
        </Spacer>
      </Accordion>
    </Col>
  );
};

export default SlideDynamicImageField;
